import { tenantConfig } from '@/lib/sovereign';

interface TenantLogoProps {
  size?: number;
  className?: string;
}

export function TenantLogo({ size = 36, className = '' }: TenantLogoProps) {
  const logoUrl = tenantConfig.identity.logoUrl;

  if (logoUrl) {
    const base = import.meta.env.BASE_URL?.replace(/\/$/, '') || '';
    const src = logoUrl.startsWith('/api/v1/') ? `${base}${logoUrl}` : logoUrl;
    return (
      <img
        src={src}
        alt={`${tenantConfig.identity.name} logo`}
        width={size}
        height={size}
        className={`object-contain ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div
      className={`flex items-center justify-center bg-brand/10 border border-brand/30 ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        className="text-brand"
        fill="currentColor"
        viewBox="0 0 24 24"
        style={{ width: size * 0.55, height: size * 0.55 }}
      >
        <path d={tenantConfig.identity.logoSvgPath} />
      </svg>
    </div>
  );
}
